<template>
  <div
    v-if="locsIn && !locsIn.length && formSubmitted"
    class="noresults"
    v-html="noResultsStringIn"
  />
  <div v-if="locsIn && locsIn.length" class="arztsuche_results">
    <h3 id="arztsuche_results_hl">
      Suchergebnisse ({{ locsIn.length }} Treffer gefunden)
    </h3>
    <div class="download_wrapper">
      <span
        class="button orange downloadbut"
        @click="downloadPDF"
        >Suchergebnisse als PDF</span
      >
    </div>
    <div
      v-if="locsIn.length > 49"
      v-html="maxResultsStringIn"
      class="maxResults"
      data-html2canvas-ignore
    />
    <Paginator
      :rows="rows"
      :totalRecords="locsIn.length"
      v-model:first="offset"
      @page="onPage($event)"
      data-html2canvas-ignore
    />

    <Result
      v-for="(loc, index) in pagedLocs"
      :key="loc.id"
      :loc="loc"
      :indexIn="index"
      :selectedLoc="selectedLoc"
      @click="selectLoc(loc.id)"
    />

    <Paginator
      :rows="rows"
      :totalRecords="locsIn.length"
      v-model:first="offset"
      @page="onPage($event)"
      data-html2canvas-ignore
    />
  </div>
</template>

<script>
import Paginator from "primevue/paginator";
import Result from "@/components/Result";

import { computed, ref, watchEffect, watch } from "vue";
export default {
  props: [
    "locsIn",
    "pagedLocs",
    "selectedLoc",
    "formSubmitted",
    "pdfLink",
    "paginationRows",
    "downloadUrl"
  ],
  components: { Paginator, Result },
  setup(props, { emit }) {
    const locs = ref(props.locsIn);
    const offset = ref(0);
    let rows = props.paginationRows;
    const selectedLoc = ref(props.selectedLoc);
    const maxResultsStringIn = ref(maxResultsString);
    const noResultsStringIn = ref(noResultsString);
    const formSubmittedIn = ref(props.formSubmitted);

    const onPage = (event) => {
      offset.value = event.page * rows;
      emit("page-locs", {
        start: event.page * rows,
        end: (event.page + 1) * rows,
      });
    };

    const selectLoc = (id) => {
      selectedLoc.value = id;
      emit("select-loc", id);
    };

    const downloadPDF = () => {
      emit("download-pdf");
    };

    watch(
      () => props.selectedLoc,
      (val, prevVal) => {
        selectedLoc.value = val;
      }
    );

    watchEffect(() => {
      rows = props.paginationRows;
      emit("page-locs", {
        start: 0,
        end: 1 * rows,
      });
    });

    return {
      locs,
      offset,
      onPage,
      rows,
      selectedLoc,
      selectLoc,
      maxResultsStringIn,
      noResultsStringIn,
      formSubmittedIn,
      downloadPDF,
    };
  },
};
</script>

<style>
</style>